module.exports = __webpack_public_path__ + "4aec99c88483fc07651eaae1d9dcf507.MP3";